var map = {
	"./ion-action-sheet.entry.js": [
		288,
		7
	],
	"./ion-alert.entry.js": [
		289,
		8
	],
	"./ion-app_8.entry.js": [
		290,
		9
	],
	"./ion-avatar_3.entry.js": [
		291,
		19
	],
	"./ion-back-button.entry.js": [
		292,
		20
	],
	"./ion-backdrop.entry.js": [
		293,
		45
	],
	"./ion-button_2.entry.js": [
		294,
		21
	],
	"./ion-card_5.entry.js": [
		295,
		22
	],
	"./ion-checkbox.entry.js": [
		296,
		23
	],
	"./ion-chip.entry.js": [
		297,
		24
	],
	"./ion-col_3.entry.js": [
		298,
		46
	],
	"./ion-datetime_3.entry.js": [
		299,
		12
	],
	"./ion-fab_3.entry.js": [
		300,
		25
	],
	"./ion-img.entry.js": [
		301,
		47
	],
	"./ion-infinite-scroll_2.entry.js": [
		302,
		48
	],
	"./ion-input.entry.js": [
		303,
		26
	],
	"./ion-item-option_3.entry.js": [
		304,
		27
	],
	"./ion-item_8.entry.js": [
		305,
		28
	],
	"./ion-loading.entry.js": [
		306,
		29
	],
	"./ion-menu_3.entry.js": [
		307,
		30
	],
	"./ion-modal.entry.js": [
		308,
		10
	],
	"./ion-nav_2.entry.js": [
		309,
		16
	],
	"./ion-popover.entry.js": [
		310,
		11
	],
	"./ion-progress-bar.entry.js": [
		311,
		31
	],
	"./ion-radio_2.entry.js": [
		312,
		32
	],
	"./ion-range.entry.js": [
		313,
		33
	],
	"./ion-refresher_2.entry.js": [
		314,
		13
	],
	"./ion-reorder_2.entry.js": [
		315,
		18
	],
	"./ion-ripple-effect.entry.js": [
		316,
		49
	],
	"./ion-route_4.entry.js": [
		317,
		34
	],
	"./ion-searchbar.entry.js": [
		318,
		35
	],
	"./ion-segment_2.entry.js": [
		319,
		36
	],
	"./ion-select_3.entry.js": [
		320,
		37
	],
	"./ion-slide_2.entry.js": [
		321,
		50
	],
	"./ion-spinner.entry.js": [
		322,
		15
	],
	"./ion-split-pane.entry.js": [
		323,
		51
	],
	"./ion-tab-bar_2.entry.js": [
		324,
		38
	],
	"./ion-tab_2.entry.js": [
		325,
		17
	],
	"./ion-text.entry.js": [
		326,
		39
	],
	"./ion-textarea.entry.js": [
		327,
		40
	],
	"./ion-toast.entry.js": [
		328,
		41
	],
	"./ion-toggle.entry.js": [
		329,
		14
	],
	"./ion-virtual-scroll.entry.js": [
		330,
		52
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 129;
module.exports = webpackAsyncContext;